import React, { useState } from 'react';
import { util } from "../commons";
import { MenuItem, TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function CustomTextInput(props) {
    const [showPassword, setShowPassword] = useState(false);

    let showDropDown = nestedItem => {
        if (nestedItem.config && nestedItem.options && nestedItem.options.length) {
            const dropDownOptions = nestedItem.options.map((option, index) => {
                return (
                    <MenuItem
                        key={index}
                        value={option[nestedItem.config.value]}
                        selected={
                            nestedItem.value === option[nestedItem.config.value]
                        }
                    >
                        {util.titleCase(option[nestedItem.config.key])}
                    </MenuItem>
                );
            });
            return dropDownOptions;
        } else if (nestedItem.options && nestedItem.options.length) {
            const dropDownOptions = nestedItem.options.map((option, index) => {
                return (
                    <MenuItem
                        key={index}
                        value={option.value}
                        selected={nestedItem.value === option.value}
                    >
                        {option.key}
                    </MenuItem>
                );
            });
            return dropDownOptions;
        }
    };

    let formatValue = (inputData) => {
        let dateFormat = "YYYY-MM-DD";
        if (inputData.formatDate) dateFormat = "yyyy-MM-dd";
        let value = inputData.value;
        if (inputData.type === "date") {
            value = (inputData.formatDate ? util.toISODateFormat(inputData.value, dateFormat) : util.toDateFormat(inputData.value, dateFormat))
        }

        return value;
    }
    return (
        <TextField
            id="component-simple"
            sx={{ m: 1, width: '100%' }}
            fullWidth
            margin="normal"
            variant="outlined"
            key={props.index}
            select={props.inputData.select}
            autoComplete="off"
            label={props.inputData.displayName}
            name={props.inputData.key}
            value={formatValue(props.inputData)}
            onChange={(e) => props.onChange(e, props.inputData.key)}
            multiline={props.inputData.multiline}
            step={props.inputData.step}
            required={props.inputData.required}
            style={props.styleObj}
            rowsMax={props.inputData.rowsMax}
            rows={props.inputData.rows}
            hidden={props.inputData.hidden ? true : false}
            disabled={props.inputData.editMode === undefined || props.inputData.editMode === null ?
                (!props.editMode || props.inputData.disabled) : !props.inputData.editMode}
            type={props.inputData.type === "select" ? "" : 
                  props.inputData.type === "password" ? (showPassword ? "text" : "password") : 
                  props.inputData.type}
            format="dd/MM/yyyy"
            error={
                props.inputData.error && props.inputData.error.length
                    ? true
                    : false
            }
            helperText={
                props.inputData.helperText
                    ? props.inputData.helperText
                    : props.inputData.error
            }
            slotProps={{
                // inputLabel: { shrink: true },
                input: {
                    endAdornment: props.inputData.type === "password" && (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
                htmlInput: props.inputData.inputProps
            }}
        >
            {props.inputData.select && props.inputData.options
                ? showDropDown(props.inputData)
                : ""}
        </TextField>
    );
}
